import { useState } from "react";
import { ArrowUpRight, Check, Copy, Mail } from "lucide-react";
import { CONTACT_EMAIL, GOOGLE_FORM_URL } from "../constants";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const formUrl = GOOGLE_FORM_URL;

  const copyEmail = async () => {
    await navigator.clipboard.writeText(CONTACT_EMAIL);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="submit-section section-pad page-offset">
      <div className="submit-aside">
        <p className="kicker">Momentul tău contează</p>
        <h2>Trimite-ne<br /><span>clipul.</span></h2>
        <p>Apasă pe buton și vei merge direct la formularul Google, unde încarci videoclipul și completezi datele.</p>
        <div className="contact-card">
          <span>Email pentru clipuri</span>
          <div>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            <button onClick={copyEmail} aria-label="Copiază adresa de email">
              {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
          {copied && <small>Adresă copiată</small>}
        </div>
      </div>

      <div className="submission-form">
        <a className="submit-btn" href={formUrl} target="_blank" rel="noopener noreferrer">
          Deschide formularul de trimitere <ArrowUpRight size={19} />
        </a>
        <p className="form-hint"><Mail size={15} /> Formularul Google se deschide într-o filă nouă și include câmpurile de nume, prenume, locație și detalii.</p>
      </div>
    </section>
  );
}
